import React from 'react';
import { graphql } from 'gatsby';
import Markdown from 'markdown-to-jsx';
import dayjs from 'dayjs';
import classnames from 'classnames';
import Layout from '../components/Layout';
import Main from '../components/Main';
import Container from '../components/Container';
import Seo from '../components/Seo';
import Button from '../components/Button';
import style from '../cssmodules/insightsPost.module.scss';

function InsightsPost({ data }) {
  const {
    date,
    title,
    author,
    description,
    featureImage,
  } = data.markdownRemark.frontmatter;
  const { slug } = data.markdownRemark.fields;
  const ogdate = [
    {
      name: 'publish_date',
      property: 'og:publish_date',
      content: dayjs(date).toISOString(),
    },
    {
      name: 'author',
      content: author,
    },
    {
      name: 'twitter:card',
      content: 'summary',
    },
    {
      name: 'twitter:creator',
      content: '@OpylAI',
    },
    {
      name: 'twitter:title',
      content: title,
    },
    {
      name: 'twitter:description',
      content: description,
    },
    {
      name: 'twitter:image',
      content: `https://opyl.ai${featureImage.publicURL}`,
    },
    {
      property: 'og:url',
      content: `https://opyl.ai${slug}`,
    },
    {
      property: 'og:type',
      content: 'article',
    },
    {
      property: 'og:title',
      content: title,
    },
    {
      property: 'og:description',
      content: description,
    },
  ];
  return (
    <Layout>
      <Seo
        title={`Insights | ${title}`}
        description={description}
        ogimage={featureImage.publicURL}
        slug={slug}
        meta={ogdate}
      />
      <Main>
        <Container>
          <div className="pageHeader pageHeader--withBtn">
            <h1 className="heading1">Insights</h1>
            <div className="pageHeader-btn">
              <Button link="/insights" modifyer="btnRainbow">
                &lt;&lt; Back to Insights
              </Button>
            </div>
          </div>
        </Container>
        <div className={style.intro}>
          <Container>
            <div className={classnames(style.introWrapper, 'stack')}>
              <p className={style.date}>
                {dayjs(date)
                  .format('DD/MM/YY')
                  .toLocaleString('en-AU', { timeZone: 'UTC' })}
              </p>
              <h1 className="heading2">{title}</h1>
              <p className={style.excerpt}>{description}</p>
            </div>
          </Container>
        </div>
        <Container>
          <Markdown
            className={classnames(
              style.content,
              'bodyText bodyText--altBlockquote',
              'stack'
            )}
          >
            {data.markdownRemark.html}
          </Markdown>
        </Container>
      </Main>
    </Layout>
  );
}

export default InsightsPost;

export const query = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        date(formatString: "YYYY-MM-DD")
        title
        author
        description
        featureImage {
          publicURL
        }
      }
      fields {
        slug
      }
    }
  }
`;
